import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  NgZone,
} from '@angular/core';
import { IProduct } from './product';
import { ProductService } from './products.service';
import { OnlineOrderService } from '../onlineorder/onlineorder.service';
import { OrderService } from '../onlineorder/order.service';
import { IOnlineOrder } from '../onlineorder/onlineorder';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../home/login.service';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { IRep } from '../home/rep';
import { ICartItems } from '../onlineorder/cartitems';
import { AppComponent } from '../app.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { IRepPublicData } from '../home/repPublicData';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { ILatestOnlineOrder } from '../onlineorder/latestonlineorder';

@Component({
  standalone: false,
  templateUrl: './product-list.component.html',
})
export class ProductListComponent implements OnInit {
  pageTitle: string = 'Product Samples';
  rep!: IRepPublicData;
  onlineorder!: IOnlineOrder[];
  public ooInfo: ILatestOnlineOrder;
  products!: IProduct[];
  errorMessage: string = '';
  public cameFromAccountCreation: boolean = false;
  // popUpHtml: string = "<div>products.toastPopups.addToCart" + "</div>";
  private sub!: Subscription;
  public token: any;

  public repId: string = '';
  public currentUser!: { access_token: any };
  public custName: string = '';
  // public checkResult: boolean;
  public checkResult!: string;
  @Input() public count: number = 0;
  @Output() countChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() repIdUniversal: EventEmitter<string> = new EventEmitter();
  public caption: string;
  public transErrMsg: string;
  translatedText = '';

  increment() {
    this.count++;
    this.countChange.emit(this.count);
  }
  onCountChanged(value: number) {
    this.count = value;
  }

  getToken() {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}',
    );
    this.token = this.currentUser && this.currentUser.access_token;
    return this.token;
  }
  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model = {
      q: [textToTrans],
      target: targetLang,
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                this.spinner.hide();
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 5000,
                });
                localStorage.removeItem('translatedText');
              },
            );
          },
        );
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;
            this.spinner.hide();
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000,
            });
            localStorage.removeItem('translatedText');
          },
        );
      }
    } else {
      // FIX: nest the toaster inside the completion of both translate calls
      this.translate.get(errorMessage).subscribe(
        (res: string) => {
          this.transErrMsg = res;
          console.log(res);
        },
        (error) => console.log(error),
        () => {
          // caption nested inside message completion — both resolved before toast fires
          this.translate.get(subject).subscribe(
            (res: string) => {
              this.caption = res;
              console.log(res);
            },
            (error) => console.log(error),
            () => {
              this.spinner.hide();
              this.toaster.error(this.transErrMsg, this.caption, {
                timeOut: 5000,
              });
            },
          );
        },
      );
    }
  }

  public options = {
    position: ['bottom', 'right'],
    timeOut: 6000,
    lastOnBottom: true,
    preventDuplicates: false,
    preventLastDuplicates: false,
  };

  constructor(
    private _productService: ProductService,
    private _onlineOrderService: OnlineOrderService,
    private toaster: ToastrService,
    public login: LoginService,
    private _route: ActivatedRoute,
    private _router: Router,
    private app: AppComponent,
    private zone: NgZone,
    private orderService: OrderService,
    private spinner: NgxSpinnerService,
    public translate: TranslateService,
    public admin: AdminService,
  ) {
    if (this.login.loggedIn()) {
      //call get sponsor id method and get
      var currentUser = JSON.parse(
        localStorage.getItem('authorizationData') || '{}',
      );
      this.login.userId = currentUser && currentUser.userName;

      this.login.getCustomerInfo().subscribe(
        (thing: any) => console.log(thing),
        (error: any) => console.log(error),
        () => {
          this.repId = localStorage.getItem('repId') || '';
          //console.log("CurrentID " + this.repId);

          this._productService
            .getRepInfo(this.repId.toString())
            .subscribe((rep: IRepPublicData) => {
              this.rep = rep;
              this.app.rep = rep;
            });

          //this.app.repId = this.repId;

          this.custName = localStorage.getItem('custName') || '';
          this.app.myCustName = this.custName;
        },
      );
    } else {
      this.sub = this._route.params.subscribe((params) => {
        let id = +params['id'];
        this._productService
          .getRepInfo(id.toString())
          .subscribe((rep: IRepPublicData) => {
            this.rep = rep;
            this.app.rep = rep;
          });

        this.repId = id.toString();
        localStorage.setItem('repId', id.toString());

        //this.repIdUniversal.emit(id.toString());
      });
    }

    this.custName = localStorage.getItem('custName') || '';
    this.app.myCustName = this.custName;
  }

  addToCartPopup(message: string): void {
    this.translate.get(message).subscribe((res: string) => {
      this.transErrMsg = res;
      console.log(res);
    });

    // // translate the caption
    // this.translate.get(subject).subscribe((res: string) => {
    //     this.caption = res;
    //     console.log(res);
    // });
    this.spinner.hide();
    //show the toaster popup
    this.toaster.show('<div>' + this.transErrMsg + '</div>', '', {
      timeOut: 3000,
      enableHtml: true,
    });
  }

  addProduct(sku: string, desc: string, price: number, url: string): void {
    var currentUser1 = JSON.parse(
      localStorage.getItem('authorizationData') || '{}',
    );
    this.login.token = currentUser1 && currentUser1.access_token;
    var newCount = localStorage.getItem('prodCount');

    if (Number(newCount) < 1) {
      if (this.login.loggedIn()) {
        let item1: ICartItems = {
          ProductId: sku,
          DisplayName: desc,
          ImageUrl: url,
          Price: price,
          Quantity: 1,
        };

        // this._onlineOrderService.checkIfOrdered2(sku).subscribe(thing => this.checkResult = thing,
        //     error => console.log(error), () => {
        this._onlineOrderService.checkIfOrdered2(sku).subscribe(
          (thing) => console.log(thing),
          () => {
            // if (this.checkResult = undefined) {
            if (this._onlineOrderService.addItem(item1) == true) {
              var newCount = localStorage.getItem('prodCount');

              if (newCount == null || newCount == '0') {
                this.count = 0;
              }
              this.count++;
              this.countChange.emit(this.count);
              this.app.myProdCount = this.count;
              localStorage.setItem('prodCount', this.count.toString());
              localStorage.setItem(
                'cartItems',
                JSON.stringify(this._onlineOrderService.getCart()),
              );
              this._onlineOrderService.addToOrder(sku).subscribe(
                (thing: IOnlineOrder[]) => (this.onlineorder = thing),
                (error: string) => (this.errorMessage = error),
                () => {
                  this._onlineOrderService
                    .updateShipMethodPlusTotals2()
                    .subscribe();
                },
              );
              this.addToCartPopup('products.toastPopups.addToCart');
            }
            // }
            // else {
            //     this._onlineOrderService.addItemAlreadyOrderedError();
            // }
          },
          () =>
            this.showError(
              'products.toastPopups.errors.alreadyOrdered',
              'products.toastPopups.errors.titles.title1',
              true,
            ),
        );
      } else {
        let item1: ICartItems = {
          ProductId: sku,
          DisplayName: desc,
          ImageUrl: url,
          Price: price,
          Quantity: 1,
        };
        if (this._onlineOrderService.addItem(item1) == true) {
          var newCount = localStorage.getItem('prodCount');

          if (newCount == null || newCount == '0') {
            this.count = 0;
          }
          this.count++;
          this.countChange.emit(this.count);

          //localStorage.removeItem('authorizationData');
          this.app.myProdCount = this.count;
          localStorage.setItem(
            'cartItems',
            JSON.stringify(this._onlineOrderService.getCart()),
          );

          localStorage.setItem('prodCount', this.app.myProdCount.toString());
          this.addToCartPopup('products.toastPopups.addToCart');
        }

        // if(Number(newCount) > 0)
        // {
        //     this.app.myProdCount = this.count + Number(newCount);
        //     console.log(this.app.myProdCount);
        // }
      }
    } else {
      this.showError(
        'products.toastPopups.errors.onePerOrder',
        'products.toastPopups.errors.titles.title1',
        true,
      );
    }
  }

  addProduct2(sku: string, desc: string, price: number, url: string): void {
    var currentUser1 = JSON.parse(
      localStorage.getItem('authorizationData') || '{}',
    );
    this.login.token = currentUser1 && currentUser1.access_token;
    var newCount = localStorage.getItem('prodCount');

    if (Number(newCount) < 1) {
      if (this.login.loggedIn()) {
        let item1: ICartItems = {
          ProductId: sku,
          DisplayName: desc,
          ImageUrl: url,
          Price: price,
          Quantity: 1,
        };

        console.log('Product: ' + sku)
        // this._onlineOrderService.checkIfOrdered2(sku).subscribe(thing => this.checkResult = thing,
        //     error => console.log(error), () => {
        this.orderService.checkIfOrdered2(sku).subscribe(
          (thing) => console.log(thing),
          () => {
            // if (this.checkResult = undefined) {
            if (this.orderService.addItem(item1) == true) {
              var newCount = localStorage.getItem('prodCount');

              if (newCount == null || newCount == '0') {
                this.count = 0;
              }
              this.count++;
              this.countChange.emit(this.count);
              this.app.myProdCount = this.count;
              localStorage.setItem('prodCount', this.count.toString());
              localStorage.setItem(
                'cartItems',
                JSON.stringify(this.orderService.getCart()),
              );
              this.orderService.addToOrder(sku).subscribe(
                (thing: IOnlineOrder[]) => (this.onlineorder = thing),
                (error: string) => (this.errorMessage = error),
                () => {
                  this.orderService.updateShipMethodPlusTotals2().subscribe(
                    (stuff) => {
                      //console.log(stuff);
                      //add to orderinfo local storage item, it didnt work in the service but here it did
                      localStorage.setItem('orderInfo', JSON.stringify(stuff));
                    },
                    null,
                    () => {
                      this._onlineOrderService.calculateTax().subscribe(
                        (thing2) => thing2,
                        (error) => console.log(error),
                        () => {
                          console.log('tax calculated');
                        },
                      );
                    },
                  );
                },
              );
              this.addToCartPopup('products.toastPopups.addToCart');
            }
            // }
            // else {
            //     this._onlineOrderService.addItemAlreadyOrderedError();
            // }
          },
          () =>
            this.showError(
              'products.toastPopups.errors.alreadyOrdered',
              'products.toastPopups.errors.titles.title1',
              true,
            ),
        );
      } else {
        let item1: ICartItems = {
          ProductId: sku,
          DisplayName: desc,
          ImageUrl: url,
          Price: price,
          Quantity: 1,
        };
        if (this.orderService.addItem(item1) == true) {
          var newCount = localStorage.getItem('prodCount');

          if (newCount == null || newCount == '0') {
            this.count = 0;
          }
          this.count++;
          this.countChange.emit(this.count);

          //localStorage.removeItem('authorizationData');
          this.app.myProdCount = this.count;
          localStorage.setItem(
            'cartItems',
            JSON.stringify(this.orderService.getCart()),
          );

          localStorage.setItem('prodCount', this.app.myProdCount.toString());
          this.addToCartPopup('products.toastPopups.addToCart');
        }

        // if(Number(newCount) > 0)
        // {
        //     this.app.myProdCount = this.count + Number(newCount);
        //     console.log(this.app.myProdCount);
        // }
      }
    } else {
      this.showError(
        'products.toastPopups.errors.onePerOrder',
        'products.toastPopups.errors.titles.title1',
        true,
      );
    }
  }
  ngOnInit(): void {
    //console.log(this.login.loggedIn());
    // if(this.login.refresh_token == undefined || this.login.refresh_token == null)
    // {
    //     localStorage.removeItem('authorizationData');
    //     this.login.isAuthenticated = false;
    //     this.app.loggedIn = false;
    // }

    var myCart = JSON.parse(localStorage.getItem('cartItems') || '{}');

    //Enabled in prod environment
    if (myCart !== null) {
      //this._onlineOrderService.cart = myCart;
      this.orderService.cart = myCart;
    }

    var newCount = localStorage.getItem('prodCount');
    if (Number(newCount) > 0) {
      this.count = Number(newCount);
    }

    //enable this for prod
    // if (this._onlineOrderService.getCart().length > 0) {
    //     this.app.myProdCount = this.count;
    // }
    // else {
    //     this.count = 0;
    //     this.app.myProdCount = this.count;
    //     localStorage.removeItem('prodCount');
    // }

    if (this.orderService.getCart().length > 0) {
      this.app.myProdCount = this.count;
    } else {
      this.count = 0;
      this.app.myProdCount = this.count;
      localStorage.removeItem('prodCount');
    }
    // this.sub = this._route.params.subscribe(
    //     params => {
    //         let id = +params['id'];
    //         //this._productService.getRepInfo(id.toString()).subscribe(rep => this.rep = rep);
    //         this.repId = id;
    //         //  this.zone.run(() => {
    //         this.app.myRepID = id;
    //         // this.app.custName = localStorage.getItem
    //         //this.app.rep = this.rep;
    //         // });

    //         localStorage.setItem('repId', id.toString());
    //         //this.repIdUniversal.emit(id.toString());

    //     });
    //console.log(this.app.myProdCount);

    if (this.login.loggedIn()) {
      //call get sponsor id method and get

      this.login.getCustomerInfo().subscribe(
        (thing: any) => console.log(thing),
        (error: any) => console.log(error),
        () => {
          this.repId = localStorage.getItem('repId') || '';
          // console.log("CurrentID " + this.repId);
          // TEMPORARY REMOVED THIS this.app.repId = this.repId;

          // this little bit of code sets the nav dropdown so that we are logged in. it was broken before I added this piece of code.
          if (localStorage.getItem('cameFromCreateAccount')) {
            localStorage.removeItem('cameFromCreateAccount');
            this.app.loggedIn = true;
          }

          this._onlineOrderService.latestOnlineOrder(true).subscribe({
            next: (data: ILatestOnlineOrder) => {
              //overwrite with new information.
              this.ooInfo = data;
              localStorage.setItem('orderId', JSON.stringify(data));
             //console.log(this._onlineOrderService.getCart());
              // if (data.Items.length > 0) {
              //   // add it to the temp cart.
              //   let item1: ICartItems = {
              //     ProductId: data.Items[0].ProductId,
              //     DisplayName: data.Items[0].DisplayName,
              //     ImageUrl: data.Items[0].ImageUrl,
              //     Price: data.Items[0].Price,
              //     Quantity: 1
              //   };

              //   if (this._onlineOrderService.addItem(item1) == true) {
              //     var newCount = localStorage.getItem('prodCount');

              //     if (newCount == null || newCount == '0') {
              //       this.count = 0;
              //     }
              //     this.count++;
              //     this.countChange.emit(this.count);

              //     //localStorage.removeItem('authorizationData');
              //     this.app.myProdCount = this.count;
              //     localStorage.setItem(
              //       'cartItems',
              //       JSON.stringify(this._onlineOrderService.getCart()),
              //     );

              //     localStorage.setItem(
              //       'prodCount',
              //       this.app.myProdCount.toString(),
              //     );
              //   }
              // }
            },
            complete: () => {

                    /************************** this block is to make sure the counter doesn't go up and that the cart object actually has the item ************************** */
                          if (this.ooInfo.Items.length > 0 && this._onlineOrderService.getCart().length < 1) {
                            // add it to the temp cart.
                            let item1: ICartItems = {
                              ProductId: this.ooInfo.Items[0].ProductId,
                              DisplayName: this.ooInfo.Items[0].DisplayName,
                              ImageUrl: this.ooInfo.Items[0].SmallImage,
                              Price: this.ooInfo.Items[0].Price,
                              Quantity: 1
                            };

                            if (this._onlineOrderService.addItem(item1) == true) {
                              var newCount = localStorage.getItem('prodCount');

                              if (newCount == null || newCount == '0') {
                                this.count = 0;
                              }
                              if(this.count === 0)
                              {
                                this.count++;
                                this.countChange.emit(this.count);
                              }

                              //localStorage.removeItem('authorizationData');
                              this.app.myProdCount = this.count;
                              localStorage.setItem(
                                'cartItems',
                                JSON.stringify(this._onlineOrderService.getCart()),
                              );

                              localStorage.setItem(
                                'prodCount',
                                this.app.myProdCount.toString(),
                              );
                            }
                          }


            },
          });
        },
      );
    } else {
      this.sub = this._route.params.subscribe((params) => {
        let id = +params['id'];
        //this._productService.getRepInfo(id.toString()).subscribe(rep => this.rep = rep);
        this.repId = id.toString();
        //  this.zone.run(() => {
        this.app.myRepID = id;
        // this.app.custName = localStorage.getItem
        //this.app.rep = this.rep;
        // });

        localStorage.setItem('repId', id.toString());
        //this.repIdUniversal.emit(id.toString());
      });
    }

    //should check if logged in
    // if (this.login.loggedIn()) {
    //     this.login.refreshToken()
    //         .subscribe();
    // }

    // this._productService.getProducts()
    //     .subscribe(products => this.products = products,
    //     error => this.errorMessage = <any>error);

    this._productService.getProducts2().subscribe(
      (products: IProduct[]) => (this.products = products),
      (error: any) => (this.errorMessage = <any>error),
    );

    //should check if logged in re enable for prod use
    if (this.login.loggedIn()) {
      //this._onlineOrderService.latestOnlineOrder()
      /****
                this.orderService.createOnlineOrder()
                .subscribe(order => this.onlineorder = order,
                error => this.errorMessage = <any>error, () => {***/
      // this._onlineOrderService.updateShipMethodPlusTotals2().subscribe();
      //this.orderService.updateShipMethodPlusTotals2().subscribe();
    }
  }
}
